<app-mapa-facil-v2
  [center]="[-58.443832, -34.587386]"
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaActivosComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
